import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { queryKeys } from "#shared/queryKeys/queryKeys";

import { fetchPartWithChildren } from "./fetchPartWithChildren.api";

export const partWithChildrenQuery = (id: string | undefined) => ({
  queryKey: queryKeys.parts.withChildren(id),
  queryFn: () => fetchPartWithChildren({ id }),
  staleTime: STALE_TIME,
});
